import React from 'preact/compat';
import { h } from 'preact';
import { DeleteOutlined } from '@ant-design/icons';

export function PdfDataReview(props) {

  function removeItem(item) {
    const update = props.items.filter(it => it.name !== item.name && it.description !== item.description);
    props.onChange([...update]);
  }

  return <div className={'pdf-items'}>
    <header className={'nav'}>
      <h2>Edit and review your menu items</h2>
      <nav>
        <button className={'btn primary'} onClick={() => props.onNext(props.items)}>Continue</button>
      </nav>
    </header>

    {props.sections.length > 0 &&
      <ul className={'sections'} style={"padding-top: 30px"}>
        {props.sections.map(section =>
          <li>
            <textarea value={section.name} />

            {section.items.length > 0 &&
              <ul className={'items'} style={"padding-top: 30px"}>
                {section.items.map(it =>
                  <li>
                    <textarea value={it.name} onChange={(ev) => {
                      it.name = ev.target.value;
                      props.onChange([...props.sections]);
                    }} />
                    <textarea value={it.description} onChange={(ev) => {
                      it.description = ev.target.value;
                      props.onChange([...props.sections]);
                    }} />
                    <textarea value={it.price} onChange={(ev) => {
                      it.price = ev.target.value;
                      props.onChange([...props.sections]);
                    }} />

                    <a onClick={() => removeItem(it)}>
                      <DeleteOutlined/>
                    </a>
                  </li>)}
              </ul>}
          </li>)}
      </ul>
    }
  </div>;
}
